module.exports = __webpack_public_path__ + "img/gi_tanktempur.deed8e05.png";